<div *transloco="let t">
  <app-dialog-title>
    {{ isCreate ? t("settings.add") : t("settings.update") }}
    {{ "settings.subtype" | transloco }}
  </app-dialog-title>
  <mat-dialog-content>
    <div class="content">
      <form [formGroup]="form" class="ui form">
        <div class="field">
          <label>{{ "settings.name" | transloco }}</label>
          <input formControlName="taxReturnSubTypeName" class="form-control" />
        </div>
        <div class="field">
          <label>{{ "settings.key" | transloco }}</label>
          <input
            formControlName="taxReturnSubTypeKey"
            class="form-control"
            [readonly]="isSubTypeReferenced"
          />
        </div>
        <div class="field">
          @if (priorSubTypeOptions) {
          <app-search-dropdown
            label="Prior subtype"
            [formCtrl]="taxReturnSubTypePrior"
            [listOptions]="priorSubTypeOptions"
          ></app-search-dropdown>
          } @if (taxReturnSubTypePrior?.errors?.hasLoop) {
          <span class="validation-text">{{
            "settings.cannot-use-this-prior-subtype-as-it-produces-an-infinite-chain"
              | transloco
          }}</span>
          }
        </div>
        <div class="field">
          <app-search-dropdown
            label="Status"
            [formCtrl]="taxReturnSubTypeStatus"
            [listOptions]="taxReturnSubTypeStatusList"
          ></app-search-dropdown>
        </div>
        <div class="field">
          <label>{{ "settings.starting-status" | transloco }}</label>
          <input
            formControlName="taxReturnSubTypeStartingStatus"
            class="form-control"
          />
        </div>
        <div class="field">
          <label>{{ "settings.link-document-type-id" | transloco }}</label>
          <input
            formControlName="taxReturnSubTypeLinkDocumentTypeId"
            class="form-control"
          />
        </div>
      </form>
    </div>
  </mat-dialog-content>

  <mat-dialog-actions align="end">
    <a class="go-back cancel" (click)="onClose()">{{
      "settings.cancel" | transloco
    }}</a>
    @if (!isProductionMode) {
    <button
      [disabled]="form.invalid"
      (click)="saveTaxReturnSubType()"
      class="ui primary button"
    >
      {{ isCreate ? t("settings.add") : t("settings.update") }}
      {{ "settings.subtype" | transloco }}
    </button>
    }
  </mat-dialog-actions>
</div>
